import { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";

import BaseAuth from "@/services/auth/Base";

import SignUpArgs from "@/entities/SignUpArgs";
import AuthenticatedUserOutput from "@/entities/AuthenticatedUserOutput";
import SignInOutput from "@/entities/SignInOutput";
import UserAuth from "@/entities/UserAuth";

export default class ProdAuth extends BaseAuth implements UserAuth {
  protected getAuthenticatedUser(): Promise<AuthenticatedUserOutput> {
    return Auth.currentAuthenticatedUser()
      .then(user => {
        return {
          token: user.signInUserSession.idToken.jwtToken,
          id: user.attributes.sub,
        };
      })
      .catch((err: string) => {
        if (err === "not authenticated") {
          return {
            token: "",
            id: "",
          };
        }
        throw err;
      });
  }

  signUp(cred: SignUpArgs): Promise<void> {
    return Auth.signUp(cred)
      .then(data => {
        AmplifyEventBus.$emit("localUser", data.user);
      })
  }

  signIn(email: string, password: string): Promise<SignInOutput> {
    return Auth.signIn(email, password).catch((err: any) => {
      console.log("Error signing in:", err);
      if (err.code === "UserNotConfirmedException") {
        throw {
          ...err,
          message:
            "This email address has not been confirmed yet, please check your inbox for an email from ProveraCare to verify your account.",
        };
      }
      if (err.code === "NotAuthorizedException") {
        throw {
          ...err,
          message: "Incorrect username or password.",
        };
      }
      throw err;
    });
  }

  confirmSignUp(username: string, code: string): Promise<void> {
    return Auth.confirmSignUp(username, code).then(() => {
      AmplifyEventBus.$emit("authState", "signIn");
    });
  }

  completeNewPassword(user: any, newPassword: string): Promise<void> {
    return Auth.completeNewPassword(user, newPassword, {}).then(async () => {
      await Auth.signOut();
      await AmplifyEventBus.$emit("authState", "signedOut");
    });
  }

  signOut(): Promise<void> {
    return Auth.signOut().then(() => {
      AmplifyEventBus.$emit("authState", "signedOut");
    });
  }

  forgotPassword(username: string) {
    return Auth.forgotPassword(username).then((data: any) => {
      return data;
    });
  }

  confirmForgotPassword(username: string, code: string, newPassword: string): Promise<void> {
    return Auth.forgotPasswordSubmit(username, code, newPassword).then(
      (data: any) => {
        AmplifyEventBus.$emit("authState", "signIn");
        return data;
      }
    );
  }

  changePassword(currentPassword: string, newPassword: string): Promise<string>  {
    return Auth.currentAuthenticatedUser().then(user => {
      return Auth.changePassword(user, currentPassword, newPassword);
    });
  }
}
